<template>
  <div
    :class="[
      hidden
        ? 'bg-gray-500 text-white'
        : isCorrect && isLocked
          ? 'bg-green-700 text-white'
          : isPresent && isLocked
            ? 'bg-kekkle-yellow-dark text-kekkle-dark'
            : isWrong && isLocked
              ? 'bg-gray-500 text-white'
              : isEmpty
                ? 'bg-gray-300'
                : 'animate-scale border border-black-dark bg-white text-black',
    ]"
    class="flex aspect-square h-full w-4 items-center justify-center rounded-sm border border-black-dark text-xs font-medium capitalize transition-all"
  >
    {{ hidden ? "?" : letter.character }}
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import type { CharacterState } from "@kekkle/shared/types/fields/wordle-game-state/wordle-game-state";

type Props = {
  letter: CharacterState;
  index: number;
  hidden?: boolean;
};

const props = defineProps<Props>();

const isCorrect = computed(() => props.letter.isCorrect);
const isPresent = computed(() => props.letter.isPresent);
const isEmpty = computed(() => props.letter.character === "");
const isLocked = computed(() => props.letter.isLocked);
const isWrong = computed(
  () =>
    !props.letter.isCorrect && !props.letter.isPresent && props.letter.isLocked,
);
</script>
